import Base from './Base';

class Service extends Base {
  constructor() {
    super();

    this.id = 2;
    this.name = 'service';
    this.searchQuery = 'service';
    this.title = 'Service';
  }

  getDefaultData(options = {}) {
    return {
      id: '',
      serviceCategoryId: '',
      resourceItemId: '',
      name: '',
      bookingQuestion: '',
      isProvedQueryCategory: false,
      isHidden: false,
      ...options,
      stepId: this.id,
    };
  }

  getData({ service }) {
    return service;
  }

  getRequestParams({ service }) {
    return {
      serviceId: service.id,
      serviceCategoryId: service.serviceCategoryId,
    };
  }

  getStepDataFromAppointment({ service }, appointment) {
    return {
      ...service,
      id: appointment.serviceId,
      serviceCategoryId: appointment.serviceCategoryId,
      name: appointment.serviceName,
    };
  }

  prepareResultData({ service }) {
    return {
      serviceId: service?.id,
      serviceName: service?.name,
      bookingQuestion: service?.bookingQuestion,
      resourceItemId: service?.resourceItemId,
    };
  }

  excludeStepDataFromParams(params) {
    const { serviceId, ...restParams } = params;
    return restParams;
  }

  fetchRecords(params, props) {
    return props.loadCategoriesWithServicesForBooking(params);
  }

  resetOptions({ service }) {
    let nonResettableOptions = {
      isHidden: service.allowToReset ? false : service.isHidden,
    };

    if (service.isProvedQueryCategory) {
      nonResettableOptions = {
        ...nonResettableOptions,
        serviceCategoryId: service.serviceCategoryId,
        isProvedQueryCategory: service.isProvedQueryCategory,
      };
    }

    return {
      service: this.getDefaultData(nonResettableOptions),
    };
  }
}

export default Service;
